import { configureStore } from '@reduxjs/toolkit';
import userReducer from './userSlice';
import adviceReducer from './adviceSlice';
import bloodTestReducer from './bloodTestSlice';
import prescriptionReducer from './prescriptionSlice';
import orderReducer from './orderSlice';
import patientReducer from './patientSlice';
import medicalQuestionnaireProgressReducer from './medicalQuestionnaireProgressSlice';

export const store = configureStore({
  reducer: {
    user: userReducer,
    advice: adviceReducer,
    bloodTest: bloodTestReducer,
    prescription: prescriptionReducer,
    order: orderReducer,
    patient: patientReducer,
    medicalQuestionnaireProgress: medicalQuestionnaireProgressReducer,
  },
});

export default store;
